import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wz-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  constructor() {}

  public Year!: number;
  ngOnInit() {
    this.Year = new Date().getFullYear();
  }
}
